import { Close } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

import { InboundDeliveryOverviewFragment } from "../../models/autogenerated-deliveryService-gql/graphql";
import DeliveryCard from "../deliveryCard/DeliveryCard";
import FallbackComponent from "../fallbackComponent/FallbackComponent";

interface DeliveryListProps {
  items: InboundDeliveryOverviewFragment[];
}

const DeliveryList = (props: DeliveryListProps) => {
  const { t } = useTranslation();
  const { items } = props;

  const emptyListIcon = <Close size={32} />;
  const emptyListText = t("noDeliveriesExist");

  if (items.length === 0)
    return (
      <FallbackComponent middleIcon={emptyListIcon} text={emptyListText} />
    );

  return (
    <div className="card-list">
      {items.map((item, index) => (
        <div key={index} className="card-list-item">
          <DeliveryCard delivery={item} />
        </div>
      ))}
    </div>
  );
};

export default DeliveryList;
